import { ArrowRight2, Moneys } from 'iconsax-react'
import Card from '../../../components/Card'
import { DialogTrigger } from '../../../components/ui/dialog'

interface MakeProposalCardProps {
  disabled?: boolean
}
export default function MakeProposalCard({
  disabled = false,
}: MakeProposalCardProps) {
  if (disabled)
    return (
      <Card variant="company-disabled">
        <div className="flex gap-2.5">
          <Moneys size={24} />
          <p className="font-semibold">Realizar Proposta</p>
        </div>

        <ArrowRight2 className="text-black04" size={34} />
      </Card>
    )
  return (
    <DialogTrigger>
      <Card variant="company">
        <div className="flex gap-2.5">
          <Moneys size={24} />
          <p className="font-semibold">Realizar Proposta</p>
        </div>

        <ArrowRight2 className="text-white" size={34} />
      </Card>
    </DialogTrigger>
  )
}
